export const SPORTS_ACTIVITY_TYPE = "deportes";
export const CLASSES_ACTIVITY_TYPE = "clases";

export const getActivityTypeById = (activityTypes = [], activityTypeId) =>
  activityTypes.find(
    (activityType) => String(activityType.id) === String(activityTypeId)
  );

export const getActivitiesByType = (activityTypes = [], activityTypeId) =>
  getActivityTypeById(activityTypes, activityTypeId)?.activities || [];

export const getAllActivities = (activityTypes = []) =>
  activityTypes.flatMap((activityType) =>
    (activityType.activities || []).map((activity) => ({
      ...activity,
      activityTypeId: activityType.id,
      activityTypeName: activityType.name,
    }))
  );

export const getDefaultActivitySelection = (
  activityTypes = [],
  preferredActivityType = SPORTS_ACTIVITY_TYPE
) => {
  const selectedType =
    getActivityTypeById(activityTypes, preferredActivityType) ||
    activityTypes[0] ||
    null;
  const selectedActivity = selectedType?.activities?.[0] || null;

  return {
    activityType: selectedType,
    activity: selectedActivity,
  };
};

export const getSelectedActivity = (
  activityTypes = [],
  activityTypeId,
  activityId
) => {
  if (!activityTypeId) {
    return (
      getAllActivities(activityTypes).find(
        (activity) => String(activity.id) === String(activityId)
      ) || null
    );
  }

  const activities = getActivitiesByType(activityTypes, activityTypeId);

  return (
    activities.find((activity) => String(activity.id) === String(activityId)) ||
    activities[0] ||
    null
  );
};

export const getSearcherRouteByType = (activityTypeId) =>
  String(activityTypeId) === CLASSES_ACTIVITY_TYPE
    ? "/searcher/classes"
    : "/searcher";
